// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__2bFtW","cardHeader":"styles_cardHeader__3anHv","buttons":"styles_buttons__1fZEj"};